const ListContainer = Object.freeze({
  Grid: 'LIST_CONTAINER_GRID',
  Horizontal: 'LIST_CONTAINER_HORIZONTAL',
  Vertical: 'LIST_CONTAINER_VERTICAL',
});

export default ListContainer;
